import Store from 'store/store';
import { getCookie, setCookie } from 'utils/cookies';

const cookies = {
	closed: 'MCPopupClosed',
	subscribed: 'MCPopupSubscribed',
};

const showMailchimpPopup = (mailchimpData, isLanding) => {
	try {
		const { baseUrl, lid, uuid, id, landingDelay, ignoreClosedCookie, ignoreSubscribedCookie } = mailchimpData;

		if (ignoreClosedCookie) {
			setCookie(cookies.closed, '', -1000);
		}
		if (ignoreSubscribedCookie) {
			setCookie(cookies.subscribed, '', -1000);
		}

		// Connected form mode (chimpstatic.com): script auto-initialises on load.
		// When triggered via bolt action, clear cookies and re-inject the script so
		// MailChimp re-evaluates cookie state and shows the popup.
		if (id && !uuid && !baseUrl && !lid) {
			triggerConnectedFormPopup(id);
			return;
		}

		const cookiePopupClosed = getCookie(cookies.closed);
		const cookieSubscribed = getCookie(cookies.subscribed);

		if (isLanding) {
			if (!cookiePopupClosed) {
				setTimeout(() => triggerPopup(baseUrl, lid, uuid), landingDelay * 1000);
			}
		} else {
			if (cookiePopupClosed) {
				setCookie(cookies.closed, '', -1000);
			}
			if (cookieSubscribed) {
				setCookie(cookies.subscribed, '', -1000);
			}
			triggerPopup(baseUrl, lid, uuid);
		}
	} catch (e) {}
};

// Connected form (chimpstatic.com) mode: re-inject script so MailChimp re-inits the popup
const triggerConnectedFormPopup = (id) => {
	if (typeof document === 'undefined') return;
	const existing = document.getElementById('mcjs');
	if (existing) existing.parentNode.removeChild(existing);
	const script = document.createElement('script');
	script.id = 'mcjs';
	script.async = true;
	script.src = `https://chimpstatic.com/mcjs-connected/js/users/${id}.js`;
	document.body.appendChild(script);
};

// Legacy (uuid/dojo) mode: wait for dojoRequire then call Loader
const triggerPopup = (baseUrl, lid, uuid) => {
	if (typeof window.dojoRequire !== 'undefined') {
		mailchimpPopup(baseUrl, lid, uuid);
	} else {
		const untilDojoRequireIs = setInterval(() => {
			if (typeof window.dojoRequire !== 'undefined') {
				clearInterval(untilDojoRequireIs);
				mailchimpPopup(baseUrl, lid, uuid);
			}
		}, 200);
	}
};

const mailchimpPopup = (baseUrl, lid, uuid) => {
	window.dojoRequire(
		['mojo/signup-forms/Loader'],
		L => L.start({
			baseUrl,
			uuid,
			lid,
			uniqueMethods: true
		})
	);
};

Store.on('SUBSCRIBER_POPUP', (mailchimpData, isLanding) => {
	showMailchimpPopup(mailchimpData, isLanding);
});
